import React, { useState } from 'react'
import DataTable from 'react-data-table-component'
import { CSVLink } from 'react-csv'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'


const ExportToExcel = (opts: any) => {
    const data = opts.data
    const title = opts.title.toLowerCase().replace(/\s/g, '-')
    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${title}.xlsx`)
    }

  return <Button className="me-2" variant="outline-success" onClick={exportToExcel}>Export to Excel</Button>
}

export function Table(opts: {
    getData: (fromDate:string, toDate:string) => Promise<any[]>
    title:string,
    defaultSort:string,
    columns: {
        name: string
        key: string
        selector: (row: any) => any
        sortable: boolean
        wrap: boolean
        searchable?: boolean
    }[]
}) {
    
    const [filteredData, setFilteredData] = useState<any[]>([])
    const [fetching, setFetching] = useState(false)
    const [didFetch, setDidFetch] = useState(false)
    const [filterText, setFilterText] = useState('')
    const [data, setData] = useState<any[]>([])

    const columns = opts.columns

    const searchable = opts.columns.filter(c => c.searchable).map(c => c.key)
    
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
        setFilterText(value)

        const filteredItems = data.filter(item => {
            return searchable.some(s => item[s]?.toLowerCase().includes(value.toLowerCase()))
        })
        
        setFilteredData(filteredItems)
    }

    const handleSubmit = async (event:any) => {
        event.preventDefault();
        
        const fromDate = event.target.elements.fromTime.value
        const toDate00 = event.target.elements.toTime.value
        const toDate0 = new Date(toDate00)
        toDate0.setDate(toDate0.getDate() + 1)
        const toDate = getDateFormatted(toDate0)

        
        setDidFetch(false)
        setFetching(true)

        const data = await opts.getData(fromDate, toDate)
        
        setDidFetch(true)
        setFetching(false)

        setData(data)
        setFilteredData(data)
    }

    function getDateFormatted(d:string|Date) {
        const v = new Date(d)

        const month = (v.getMonth() + 1).toString().padStart(2, '0')
        const date = v.getDate().toString().padStart(2, '0')
        return `${v.getFullYear()}-${month}-${date}` 
    }

    const start0 = new Date()
    start0.setDate(1)
    const start = getDateFormatted(start0)
    const max = getDateFormatted(new Date())
    
  return (
    <div>
        <h3>{opts.title}</h3>
        <Form onSubmit={handleSubmit}>
            <Container fluid>
                <Row className="align-items-end">
                    <Col xs={12} sm={4}>
                        <Form.Group controlId="fromTime">
                            <Form.Label>From date</Form.Label>
                            <Form.Control type="date" defaultValue={start} required max={max} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={4}>
                        <Form.Group controlId="toTime">
                            <Form.Label>To date</Form.Label>
                            <Form.Control type="date" required defaultValue={max} max={max} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={4}>
                        <Button type="submit">Submit</Button>
                    </Col>
                </Row>
            </Container>
        </Form>

        <hr />

        {fetching ? (
            <Spinner animation="border" />
        ) : didFetch ? (
            <>
                <div className="mt-2 d-flex justify-content-between mb-3">
                    <Form.Group controlId="search" className="mb-0">
                        <Form.Control
                            type="text"
                            placeholder="Search"
                            value={filterText}
                            onChange={handleSearch}
                        />
                    </Form.Group>
                    <div>
                        <CSVLink data={filteredData} filename={`${opts.title.toLowerCase().replace(/\s/g, '-')}.csv`}>
                            <Button variant="outline-secondary" className="me-2">
                                Export to CSV
                            </Button>
                        </CSVLink>
                        <ExportToExcel data={filteredData} title={opts.title} />
                    </div>
                </div>
                <div className='me-2'>
                <DataTable
                    title={opts.title}
                    columns={columns}
                    data={filteredData}
                    pagination
                    persistTableHead
                    responsive
                    noHeader
                    defaultSortFieldId={opts.defaultSort}
                    defaultSortAsc={false}
                />
    </div>
            </>
        ) : (
            ''
        )}
    </div>
)
}

